import Navbar from '../../components/navbar/nav';
import Footer from '../../components/footer/footer';
import AboutSection from '../../components/about/AboutSection';
import './home.css';

function Home() {
  return (
    <main>
      <Navbar />
      <section className="home-hero position-relative">
        {/* Video de fondo */}
        <video
          className="home-hero-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="/videos/ableton1.mp4" type="video/mp4" />
          Tu navegador no soporta la reproducción de video.
        </video>

        {/* Overlay degradado */}
        <div className="home-hero-overlay"></div>

        {/* Contenido centrado */}
        <div className="containerh position-relative">
          <img
            src="/images/Logo-PNG.png"
            alt="VPA Logo"
            className="logo-heartbeat animate__animated animate__bounceIn"
          />
        <br />
        <br />
          <a
            href="/tienda"
            className="btn store-button animate__animated animate__fadeIn"
          >
            <i className="bi bi-shop me-2"></i>
            Explora nuestra tienda
          </a>
        </div>
      </section>

      <AboutSection />
      <Footer />
    </main>
  );
}

export default Home;
